"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerFragmentsMinimal = exports.customerFragments = exports.bosCustomerFragmentMinimal = exports.bosCustomerFragment = exports.customerFragmentWithBosMinimal = exports.customerFragmentWithBos = exports.customerFragment = exports.customerReferenceFragment = void 0;
const reference_1 = require("./reference");
const vehicle_1 = require("./vehicle");
exports.customerReferenceFragment = `
  fragment customerReference on Customer {
    id
    reference {
      ...reference
    }
    timestamp
  }
`;
exports.customerFragment = `
  fragment customer on Customer {
    id
    buyerOrder {
      id
    }
    customerType
    order {
      id
    }
    reference {
      ...reference
    }
    ssn
    signingMobilePhone
    organizationNo
    phoneNumber
    timestamp
    vehicles {
      ...vehicle
    }
  }
`;
exports.customerFragmentWithBos = `
  fragment customer on Customer {
    id
    bosCustomer {
      ... bosCustomer
    }
    buyerOrder {
      id
    }
    customerType
    order {
      id
    }
    ssn
    signingMobilePhone
    organizationNo
    phoneNumber
    reference {
      ...reference
    }
    timestamp
    vehicles {
      ...vehicle
    }
  }
`;
exports.customerFragmentWithBosMinimal = `
  fragment customer on Customer {
    id
    bosCustomer {
      ...bosCustomerMinimal
    }
    buyerOrder {
      id
    }
    customerType
    order {
      id
    }
    reference {
      ...reference
    }
    ssn
    signingMobilePhone
    organizationNo
    phoneNumber
    timestamp
    vehicles {
      ...vehicle
    }
  }
`;
exports.bosCustomerFragment = `
  fragment bosCustomer on BosCustomer {
      address1
      address2
      city
      comment
      communicationBulkEmail
      communicationCsi
      communicationEmail
      communicationFax
      communicationMail
      communicationMarketingMaterials
      communicationPhone
      communicationSMS
      corporateForm
      countryCode
      customerType
      dateOfBirth
      dateOfBirthFields
      email
      fax
      firstName
      gender
      id
      idNumber
      industry
      isValidated
      lastName
      maritialStatus
      mosaicCode
      organizationName
      organizationNo
      ownership
      partitionKey
      phoneMobile
      phonePrivate
      phoneWork
      serviceAgreement
      status
      timestamp
      tiresHotel
      type
      validationCode
      webSite
      zipCode
  }
`;
exports.bosCustomerFragmentMinimal = `
  fragment bosCustomerMinimal on BosCustomer {
      address1
      address2
      city
      countryCode
      customerType
      dateOfBirth
      dateOfBirthFields
      email
      firstName
      gender
      id
      isValidated
      lastName
      organizationName
      organizationNo
      phoneMobile
      status
      zipCode
  }
`;
exports.customerFragments = `
  ${exports.bosCustomerFragment}
  ${exports.customerFragmentWithBos}
  ${reference_1.referenceFragment}
  ${vehicle_1.vehicleFragment}
  ${vehicle_1.vehicleConfigurationFragment}
  ${vehicle_1.vehicleModelFragment}
  ${vehicle_1.vehicleStatusFragment}
  ${vehicle_1.vehicleInventoryFragment}
`;
exports.customerFragmentsMinimal = `
  ${exports.bosCustomerFragmentMinimal}
  ${exports.customerFragmentWithBosMinimal}
  ${reference_1.referenceFragment}
  ${vehicle_1.vehicleFragment}
  ${vehicle_1.vehicleConfigurationFragment}
  ${vehicle_1.vehicleModelFragment}
  ${vehicle_1.vehicleStatusFragment}
  ${vehicle_1.vehicleInventoryFragment}
`;
//# sourceMappingURL=customer.js.map